import { Avatar, Flex, Tooltip } from '@televet/kibble-ui';
import React, { MouseEvent, ReactNode } from 'react';
import { useSidePanelSearch } from 'shared/components/SidePanel/components/SearchPanel/state/providers/SearchPanelProvider';

interface IProps {
  children: ReactNode[];
  max?: number;
  petParentNames?: string;
  firstPetParentId?: string;
}

const AvatarGroup = ({ children, max = 2, petParentNames, firstPetParentId }: IProps): JSX.Element => {
  const { viewClinicPetParent } = useSidePanelSearch();

  return (
    <Tooltip label={petParentNames || ''}>
      <Flex className="AvatarGroup__Container" align="flex-start" justify="flex-start">
        {max && children.length > max ? (
          <Avatar
            onClick={(e: MouseEvent): void => {
              e.stopPropagation();
              viewClinicPetParent({ clinicPetParentId: firstPetParentId || '' });
            }}
            cursor="pointer"
            name={children.length.toString()}
            showTooltip={false}
          />
        ) : (
          children
        )}
      </Flex>
    </Tooltip>
  );
};

export default AvatarGroup;
